import { Routes } from '@angular/router';

import { authOnlyGuard, guestOnlyGuard, superAdminOnlyGuard } from '@vdms-hq/auth';
import { environment } from '../environments/environment';

const title = `VIDA Content OS v${environment.version} ${new Date().getFullYear()}`;

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'ui-playground',
    title,
    // internal component gallery — super admins only (order matters: the auth
    // guard must run first, see superAdminOnlyGuard)
    canActivate: [authOnlyGuard, superAdminOnlyGuard],
    loadChildren: () => import('@vdms-hq/playground').then((m) => m.playgroundRoutes),
  },
  {
    path: 'login',
    title,
    canActivate: [guestOnlyGuard],
    loadChildren: () => import('@vdms-hq/login').then((m) => m.loginRoutes),
  },
  {
    path: 'download',
    title,
    loadChildren: () => import('./guest-download/guest-download.routes').then((m) => m.guestDownloadRoutes),
  },
  {
    path: 'order',
    title,
    loadChildren: () => import('./guest-download/guest-download.routes').then((m) => m.guestDownloadRoutes),
  },
  {
    path: 'youtube-auth',
    title,
    loadChildren: () => import('@vdms-hq/credentials').then((m) => m.YOUTUBE_AUTH_ROUTING),
  },
  {
    path: '',
    title,
    loadChildren: () => import('./secured/secured.routes').then((m) => m.securedRoutes),
  },
  { path: '**', redirectTo: '' },
];
